require('./style.less');
const size = require('../../modules/size');

class BigLink {
    constructor(element) {
        this.bigLinkList = element;
        this.checkScroll();
        this.setEvents();
    }
    deleteBigLinkScroll() {
        const bigLinkListStyle = window.getComputedStyle(this.bigLinkList);
        const bigLinkListPaddingRight = this.bigLinkList.offsetWidth - this.bigLinkList.clientWidth;
        const bigLinkListMarginRight = parseInt(bigLinkListStyle.getPropertyValue('margin-right'), 10);
        this.bigLinkList.style.paddingRight = bigLinkListPaddingRight + 'px';
        this.bigLinkList.style.width = `calc(100% + ${bigLinkListPaddingRight - bigLinkListMarginRight}px)`;
    }
    checkScroll() {
        if (window.innerWidth < size.tablet) {
            this.deleteBigLinkScroll();
        } else {
            this.bigLinkList.setAttribute('style', '');
        }
    }

    setEvents() {
        $(window).resize(() => {
            this.checkScroll();
        });
    }
}

$(window).load(() => {
    const bigLinkList = document.querySelector('.big-link__list');
    if (bigLinkList !== null) {
        new BigLink(bigLinkList);
    }
});



// WEBPACK FOOTER //
// ./blocks/big-link/index.js